import React from 'react'
import { Link } from 'react-router-dom'

// Soft UI Dashboard PRO React components

import Button from '@mui/material/Button'
import { Typography, Box } from '@mui/material'
import WestIcon from '@mui/icons-material/West'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

export const QuestionContainer = React.memo(
  ({
    StepComponent,
    activeStep,
    handleNext,
    handleSkipSection,
    required = false,
    userNotification,
    isLastStep,
    handleBack,
    isDisabled,
    stepComponentProps,
    completionStepProps,
    handleCompleteOnboarding,
    fieldErrors,
    setFieldErrors,
    handleFieldFocus,
    removeBottomPadding = false,
    ...props
  }) => {
    const currentStep = window.location.search

    const buttonCTA =
      window.location.pathname === '/seminar' ||
      window.location.pathname === '/' ||
      window.location.pathname === '/complementary' ||
      window.location.pathname === '/full' ||
      window.location.pathname === '/ic' ||
      window.location.pathname === '/report' ||
      window.location.pathname === '/fork-flow' ||
      window.location.pathname === '/onboarding-flow' ||
      window.location.pathname === '/event' ||
      window.location.pathname === '/quick-onboarding' ||
      window.location.pathname === '/walter-reed' ||
      window.location.pathname === '/firststep' ||
      window.location.pathname === '/schedule'
        ? 'Create Your Account'
        : window.location.pathname !== '/dashboard'
        ? 'Close'
        : 'Head to the Dashboard'
    const buttonLink =
      window.location.pathname === '/onboarding-flow'
        ? '/onboarding-full?onboardingStep=pickYourPath'
        : window.location.pathname === '/event'
        ? '/onboarding-full?onboardingStep=pickYourPath'
        : currentStep === '?onboardingStep=interstitialHeadToDashboard'
        ? '/dashboard'
        : window.location.pathname === '/quick-onboarding'
        ? '/onboarding-full?onboardingStep=pickYourPath'
        : window.location.pathname === '/schedule'
        ? '/onboarding-full?onboardingStep=pickYourPath'
        : window.location.pathname === '/walter-reed'
        ? '/onboarding-full?onboardingStep=pickYourPath'
        : window.location.pathname === '/fork-flow'
        ? '/onboarding-full?onboardingStep=retirementGoals'
        : window.location.pathname === '/onboarding-full'
        ? '/dashboard'
        : window.location.pathname
    const nextButtonMap = {
      '?onboardingStep=onboardingSchedule': 'Skip Scheduling',
      '?onboardingStep=netWorthAssetReview': 'Looks good!',
      '?onboardingStep=tspLoansValue': 'Looks good!',
      '?onboardingStep=deductionsReview': 'Looks good!',
      '?onboardingStep=lifeInsuranceOtherPrivateLifeInsurance': 'Looks good!',
      '?onboardingStep=netWorthLiabilityReview': 'Looks good!',
      '?onboardingStep=TSPPage4': 'Looks good!',
      '?onboardingStep=familyChildren': 'Looks good!',
      '?onboardingStep=interstitialHeadToDashboard': 'Create Account',
      '?onboardingStep=interstitialContinueOnboarding': 'Create Account',
    }
    const nextButtonText = nextButtonMap[currentStep] || 'next'

    return (
      <Box px={{ xs: 1, sm: 2 }} py={{ xs: 1, sm: 2 }}>
        <Box p={0}>
          {StepComponent && (
            <StepComponent
              key={`step-component-${activeStep}`}
              handleNext={handleNext}
              fieldErrors={fieldErrors}
              setFieldErrors={setFieldErrors}
              onFieldFocus={handleFieldFocus}
              questionContainerNext={handleNext}
              questionContainerBack={handleBack}
              {...completionStepProps}
              {...stepComponentProps}
              {...props}
              required={required}
            />
          )}
          <Box
            width="100%"
            display="flex"
            gap={2}
            justifyContent={
              isLastStep
                ? 'center'
                : stepComponentProps?.inputType === 'deductionsReview' ||
                  currentStep === '?onboardingStep=onboardingSchedule' ||
                  currentStep === '?onboardingStep=tspSavings'
                ? 'flex-end'
                : 'space-between'
            }
            alignItems="center"
            sx={{
              position: 'relative',
              paddingBottom: removeBottomPadding ? '0px ' : '32px',
            }}
          >
            {activeStep === 0 || isLastStep ? (
              <></>
            ) : stepComponentProps?.inputType === 'deductionsReview' ? (
              <></>
            ) : currentStep === '?onboardingStep=onboardingSchedule' ||
              currentStep === '?onboardingStep=calculatingSpinner' ||
              currentStep === '?onboardingStep=tspSavings' ? (
              <></>
            ) : (
              <Button
                variant="parcoRounded"
                color="outline"
                onClick={handleBack}
              >
                Back
              </Button>
            )}

            {isLastStep || stepComponentProps?.appointment ? (
              <Link to={buttonLink}>
                <Button
                  onClick={() => {
                    userNotification('User has just completed Onboarding')
                    handleCompleteOnboarding && handleCompleteOnboarding()
                  }}
                  variant="parcoRounded"
                >
                  {buttonCTA}
                </Button>
              </Link>
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                {currentStep === '?onboardingStep=onboardingSchedule' ||
                currentStep === '?onboardingStep=interstitialWhatsNext' ||
                currentStep === '?onboardingStep=calculatingSpinner' ||
                StepComponent?.name === 'OnboardingYesNo' ||
                StepComponent?.name === 'OnboardingMultiOptionTile' ? (
                  <></>
                ) : (
                  <Button
                    variant="parcoRounded"
                    onClick={handleNext}
                    disabled={isDisabled}
                  >
                    {nextButtonText}
                  </Button>
                )}
              </Box>
            )}

            {!isLastStep &&
              !stepComponentProps?.appointment &&
              window.location.href.includes('interstitial') &&
              !window.location.href.includes('interstitialFinalSteps') &&
              !window.location.href.includes('interstitialWhatsNext') &&
              !window.location.href.includes(
                'interstitialContinueOnboarding'
              ) && (
                <Typography
                  sx={{
                    position: 'absolute',
                    fontSize: '14px',
                    right: '4px',
                    top: '56px',
                    color: '#A3a7AA',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }}
                  variant="body3Light"
                  onClick={handleSkipSection}
                >
                  Skip section
                </Typography>
              )}
          </Box>
        </Box>
      </Box>
    )
  }
)

QuestionContainer.displayName = 'QuestionContainer'
